import React from 'react';
import { CloseXIcon } from '../../../../UI/Icons/Icons';
import * as styles from './ImboxModalStyles.module.scss';

export function ImboxModalContent({ baseCharge, onAdd, onDecline, onClose }) {
  return (
    <div
      id={styles.reactImboxModalContent}
      role='dialog'
      aria-modal='true'
      aria-labelledby='imbox-modal-title'
      aria-describedby='imbox-modal-desc'
      tabIndex={-1}
    >
      <div>
        <button id={styles.closeImboxModal} aria-label='Close IMBOX modal' onClick={onClose} type='button'>
          <CloseXIcon />
        </button>
        <h2 className={styles.imboxHeadline}>Protect your new shoes with IMBOX Shoe Protection</h2>
        <div>
          <p className={styles.imboxTagline}>
            <span className={styles.makeBold}>IMBOX Shoe Protection</span> is a professional treatment that creates an
            invisible protective layer on shoes. Engineered to repel water, dirt, and UV rays, this patented treatment
            helps prolong the lifespan of footwear by guarding against everyday stains, spills, and color fading.
          </p>
        </div>
        <ul className={styles.productInfo} aria-label='IMBOX product highlights'>
          <li className={styles.productHighlight}>
            <span aria-hidden='true' className={styles.checkmarkIcon}>
              <svg
                stroke='currentColor'
                fill='none'
                strokeWidth='2'
                viewBox='0 0 24 24'
                height='26px'
                width='26px'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                focusable='false'
                style={{ color: 'green' }}
              >
                <rect x='2' y='2' width='20' height='20' rx='0' stroke='black' fill='none' />
                <path d='M5 13L10 17L19 6' stroke='green' strokeWidth='3' fill='none' />
              </svg>
            </span>
            <div>
              <h3>All-weather protection</h3>
              <p>
                IMBOX Shoe Protection shields your footwear against water, stains, dirt, and color fading due to UV
                radiation. This invisible protection helps prolong the life of your shoes while maintaining their
                breathability and appearance.
              </p>
            </div>
          </li>
          <li className={styles.productHighlight}>
            <span aria-hidden='true' className={styles.checkmarkIcon}>
              <svg
                stroke='currentColor'
                fill='none'
                strokeWidth='2'
                viewBox='0 0 24 24'
                height='26px'
                width='26px'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                focusable='false'
                style={{ color: 'green' }}
              >
                <rect x='2' y='2' width='20' height='20' rx='0' stroke='black' fill='none' />
                <path d='M5 13L10 17L19 6' stroke='green' strokeWidth='3' fill='none' />
              </svg>
            </span>
            <div>
              <h3>Safe and environmentally friendly</h3>
              <p>
                The IMBOX Shoe Protection treatment is AllergyCertified and free from PFAS and carcinogens, ensuring it
                is safe for both you and the environment.
              </p>
            </div>
          </li>
          <li className={styles.productHighlight}>
            <span aria-hidden='true' className={styles.checkmarkIcon}>
              <svg
                stroke='currentColor'
                fill='none'
                strokeWidth='2'
                viewBox='0 0 24 24'
                height='26px'
                width='26px'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                focusable='false'
                style={{ color: 'green' }}
              >
                <rect x='2' y='2' width='20' height='20' rx='0' stroke='black' fill='none' />
                <path d='M5 13L10 17L19 6' stroke='green' strokeWidth='3' fill='none' />
              </svg>
            </span>
            <div>
              <h3>Works on a wide range of footwear</h3>
              <p>
                IMBOX Shoe Protection is suitable for almost all types of shoes, including running shoes, sandals,
                sneakers, and winter boots. Rubber boots and shoes made entirely of patent leather do not benefit from
                the treatment.
              </p>
            </div>
          </li>
        </ul>
        <div className={styles.addImboxProtection}>
          <button data-twist='add-imbox-protection' className='btn btn-primary' onClick={onAdd}>
            Add IMBOX Shoe Protection + ${baseCharge}
          </button>
        </div>
        <div className={styles.declineImboxProtection}>
          <button data-twist='decline-imbox-protection' onClick={onDecline}>
            No thanks
          </button>
        </div>
        <div className={styles.footerNote}>
          <p className='text-center'>
            Products purchased and treated with IMBOX Shoe Protection are subject to a one-time, non-refundable $
            {baseCharge} charge. If you choose to return a treated item, the ${baseCharge} charge will be deducted from
            your total refund.
          </p>
        </div>
      </div>
    </div>
  );
}
